import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getOnboardingList(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("getOnboardingList", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    getAccountOnboarding(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("getAccountOnboarding", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    getDocumentTypes(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("getOnboardingDocumentTypes")
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    addRequiredDocument(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("addOnboardingRequiredDocument", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    removeRequiredDocument(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("removeOnboardingRequiredDocument", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    getClientUsers(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("getOnboardingClientUsers")
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    createContact(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("createOnboardingContact", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    resendContactLink(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("resendOnboardingContactLink", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    revokeContact(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("revokeOnboardingContact", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    freezeContact(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("freezeOnboardingContact", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    reactivateContact(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("reactivateOnboardingContact", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    uploadInternalDocument(ctx, formData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("uploadOnboardingInternalDocument", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    deleteDocument(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("deleteOnboardingDocument", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    downloadDocument(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("downloadOnboardingDocument", {
            params: { documentId: data.documentId },
            responseType: "blob",
          })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    getSignatureImage(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("getOnboardingSignatureImage", {
            params: { onboardingId: data.onboardingId, which: data.which },
            responseType: "blob",
          })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    previewForm(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("previewOnboardingForm", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    previewPackage(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("previewOnboardingPackage", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    addPackage(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("addOnboardingPackage", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    removePackage(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("removeOnboardingPackage", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    syncPackages(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("syncOnboardingPackages", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    sendReminder(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("requestOnboardingDocuments", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    reviewDocument(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("reviewOnboardingDocument", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    reattachDocument(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("reattachOnboardingDocument", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    declineCustomerRequest(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("declineOnboardingCustomerRequest", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    getActivityLog(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("getOnboardingActivityLog", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
